import { Newspaper, ExternalLink, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/format";

export function PressSection({ items = [], onAdd, onDelete, className = "" }) {
  const hasItems = items.length > 0;
  return (
    <div className={className} data-testid="press-section">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Newspaper className="h-5 w-5 text-[#35606E]" />
          <h2 className="font-display text-xl font-bold">Press <span className="text-neutral-400">({items.length})</span></h2>
        </div>
        {onAdd && (
          <Button data-testid="add-press-btn" onClick={onAdd} variant="outline" className="rounded-full border-[#35606E]/30 bg-white text-[#35606E] hover:bg-[#35606E]/5">
            <Plus className="mr-1.5 h-4 w-4" /> Add press
          </Button>
        )}
      </div>

      {!hasItems ? (
        <div className="pb-card flex flex-col items-center gap-2 p-10 text-center">
          <Newspaper className="h-8 w-8 text-neutral-300" />
          <p className="text-sm font-medium text-neutral-600">No press yet</p>
          {onAdd && <p className="text-xs text-neutral-500">Paste a press article link and we'll pull the headline, outlet and date.</p>}
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div key={p.id} data-testid={`press-item-${p.id}`} className="pb-card group flex items-center gap-4 p-4">
              {p.thumbnail ? (
                <img src={p.thumbnail} alt="" className="h-11 w-11 shrink-0 rounded-xl object-cover" />
              ) : (
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#35606E]/10 text-[#35606E]">
                  <Newspaper className="h-5 w-5" />
                </span>
              )}
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-neutral-900 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white">{p.outlet}</span>
                  {p.date && <span className="text-xs text-neutral-500">{fmtDate(p.date)}</span>}
                </div>
                <a href={p.link} target="_blank" rel="noopener noreferrer" className="mt-1 flex items-center gap-1 font-semibold leading-tight hover:text-[#35606E]">
                  <span className="truncate">{p.title}</span>
                  <ExternalLink className="h-3.5 w-3.5 shrink-0 text-neutral-300 group-hover:text-[#35606E]" />
                </a>
              </div>
              {onDelete && (
                <button data-testid={`delete-press-${p.id}`} onClick={() => onDelete(p)} className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-neutral-300 transition-colors hover:bg-red-50 hover:text-red-600">
                  <Trash2 className="h-4 w-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
